/**
 * Справочник специализаций врачей: GET /admin/refs/specializations.
 * UI показывает имена, бэку уезжают id (маппят мутации врачей/клиента).
 * Мок — фиксированный список из refs.
 */

import {apiEnabled, http} from '@services/utils';

import {SPECIALIZATION_OPTIONS} from '../refs';

export type SpecializationRef = {id: string; name: string};

const asObj = (v: unknown): Record<string, unknown> =>
  (typeof v === 'object' && v !== null ? v : {}) as Record<string, unknown>;

/** Кэш на сессию — справочник статичный */
let cache: Promise<SpecializationRef[]> | null = null;

export const getSpecializations = (): Promise<SpecializationRef[]> => {
  if (!apiEnabled) {
    return Promise.resolve(SPECIALIZATION_OPTIONS.map((name) => ({id: name, name})));
  }
  cache ??= http<unknown[]>('admin/refs/specializations', {skipCaseConversion: true})
    .then((list) =>
      (Array.isArray(list) ? list : []).map((raw) => {
        const r = asObj(raw);
        return {
          id: typeof r.id === 'string' ? r.id : '',
          name: typeof r.name === 'string' ? r.name : '',
        };
      }),
    )
    .catch((e: unknown) => {
      cache = null;
      throw e;
    });
  return cache;
};
